export default {
    SEARCH_RESULT_PAGE: 'SEARCH_RESULT_PAGE',
    CATEGORY_RESULT_PAGE: 'CATEGORY_RESULT_PAGE'
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/constants/page-types.js